<template>
  <div class="col-12 col-lg-6">
    <div class="row">
      <div class="col-12">
        <div class="pane-header">
          <span class="icon"><icon-colored-calendar /></span>
          <span>{{ capitalize($t('names.date', { n: 2 })) }}</span>
        </div>
      </div>
      <div class="col-12">
        <div class="pane-content">
          <div class="row">
            <div class="col-6">
              <h4>{{ capitalize($t('names.start', { n: 1 })) }}</h4>
              <span
                id="package_details_start_date"
                class="text-muted"
                >{{ props.deal.startDateDescription }}</span
              >
              <input
                id="package_details_start_date_min_value"
                aria-hidden="true"
                type="hidden"
                :value="props.deal.startDate.toLocaleString()" />
            </div>
            <div class="col-6">
              <h4>{{ capitalize($t('names.end', { n: 1 })) }}</h4>
              <span
                id="package_details_end_date"
                class="text-muted"
                >{{ props.deal.endDateDescription }}</span
              >
              <input
                id="package_details_end_date_max_value"
                aria-hidden="true"
                type="hidden"
                :value="props.deal.endDate.toISO()" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { capitalize } from 'vue';

  import { IconColoredCalendar } from '@/common/icons/colored';
  import { Package } from '@/common/models';

  interface IDealDetailsDates {
    deal: Package;
  }

  const props = defineProps<IDealDetailsDates>();
</script>

<style lang="scss" scoped>
  @use '@/styles/variables.scss' as *;
</style>
